import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton, Typography, Paper, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: "#FFEEEE",
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  padding: {
    paddingLeft: theme.spacing(2),
  },
}));

export function ErrorMessages({
  errorMessages,
  onClose,
  hideTitle,
  hideCloseButton,
  disableScrollToTop,
}) {
  const classes = useStyles();

  useEffect(() => {
    if (
      !disableScrollToTop &&
      errorMessages?.length > 0 &&
      window &&
      window.scrollTo
    ) {
      window.scrollTo(0, 0);
    }
  }, [errorMessages.length, disableScrollToTop]);

  return errorMessages.length > 0 ? (
    <Grid container data-testid="error-messages">
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container justifyContent="space-between" alignItems="center">
            {!hideTitle && (
              <Typography align="left" variant="body2">
                {errorMessages.length} errors prohibited this form from being
                saved:
              </Typography>
            )}
            {!hideCloseButton && (
              <IconButton name="errors" onClick={onClose}>
                <CloseIcon style={{ color: "#F96868" }} />
              </IconButton>
            )}
          </Grid>
          <Grid container>
            {errorMessages.map((error) => (
              <Grid item key={error.key} xs={12} className={classes.padding}>
                {error.message.length > 0 ? (
                  <Typography align="left" variant="body2">
                    * {error.message}
                  </Typography>
                ) : null}
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  ) : null;
}

ErrorMessages.propTypes = {
  errorMessages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    })
  ),
  onClose: PropTypes.func,
  hideTitle: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  disableScrollToTop: PropTypes.bool,
};
ErrorMessages.defaultProps = {
  errorMessages: [],
  hideTitle: false,
  hideCloseButton: false,
  disableScrollToTop: false,
  onClose: (f) => f,
};
